import React from 'react';
import { connect } from 'react-redux';
import { startSetGeoName } from '../actions/globalState';
import {Select} from 'antd';
const Option = Select.Option;

export class GeoNameType extends React.Component {

  onGeoNameChange = (value) => {
    this.props.startSetGeoName(value);
  };

  
  render() {
    return (
      <Select  size="large"
        showSearch
        className="geo_name"
        placeholder="Select a suburb"
        optionFilterProp="children"
        value={this.props.geo_name}
        onChange={value => this.onGeoNameChange(value)}
        >
        {
          this.props.geo_names.length === 0 ? 
          (<Option value="Brisbane (C)">Brisbane (C)</Option>) : 
          ( this.props.geo_names.map((item, index) => {
            return <Option key={index} value={item.geo_name}>{item.geo_name}</Option>
          }))
        }
      </Select>
    )
  }
}

const mapStateToProps = (state) => ({
  geo_name: state.globalState.geo_name,
  geo_names: state.globalState.geo_names
});

const mapDispatchToProps = (dispatch) => ({
  startSetGeoName: (text) => dispatch(startSetGeoName(text))
});

export default connect(mapStateToProps, mapDispatchToProps)(GeoNameType);



// WEBPACK FOOTER //
// ./src/components/GeoNameType.js